module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/trash/trash.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/trash/trash.png
// module id = 642
// module chunks = 0